__turbopack_context__.v({
  "content": "playbook-page-module-scss-module__eqZtWq__content",
  "wrapper": "playbook-page-module-scss-module__eqZtWq__wrapper",
});
